export const PAGE_ATTACHMENTS_CHANGED = "page-attachments-changed";

export const notifyPageAttachmentsChanged = (caseId, pageId, type) => {
  window.dispatchEvent(
    new CustomEvent(PAGE_ATTACHMENTS_CHANGED, { detail: { caseId, pageId, type } })
  );
};
